import type { PackageTier } from "../types";

interface Props {
  tier: PackageTier;
  onChange: (tier: PackageTier) => void;
}

const TIERS: { id: PackageTier; label: string }[] = [
  { id: "cheapest", label: "Cheapest" },
  { id: "best_value", label: "Best Value" },
  { id: "premium", label: "Premium" },
];

export function PackageSelector({ tier, onChange }: Props) {
  return (
    <div className="inline-flex rounded-lg border border-slate-300 bg-white p-1">
      {TIERS.map((t) => (
        <button
          key={t.id}
          onClick={() => onChange(t.id)}
          className={
            "rounded-md px-3 py-1.5 text-sm font-medium transition " +
            (tier === t.id
              ? "bg-brand-600 text-white"
              : "text-slate-600 hover:bg-slate-100")
          }
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
